
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35464',
  depVersions: {
  "documents-public-ui": "static-1.35464",
  "atom": "static-1.5508",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2915",
  "client-types": "static-1.507",
  "cssUtils": "static-1.1053",
  "customer-data-filters-ui": "static-1.41254",
  "customer-data-objects": "static-1.8124",
  "customer-data-property-utils": "static-1.8475",
  "documents-lib": "static-1.35469",
  "emoji-mart": "static-3.6",
  "flux-actions": "static-1.380",
  "FormsCommonComponents": "static-1.86764",
  "FormUrlGenerator": "static-2.5145",
  "foundations-theming-specialty": "static-1.2629",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.114",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6020",
  "hs-test-utils": "static-1.8468",
  "hub-http": "static-1.6639",
  "hubspot-dlb": "static-2.1911",
  "HubStyle": "static-2.12229",
  "HubStyleTokens": "static-2.11922",
  "I18n": "static-7.1698",
  "icons": "static-2.699",
  "jasmine-immutable": "static-1.3373",
  "jasmine-runner": "static-1.6881",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7581",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3316",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5810",
  "quartz": "static-1.7606",
  "react": "static-7.202",
  "react-dlb": "static-1.92",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17165",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5635",
  "react-virtualized": "static-2.111",
  "reference-resolvers": "static-1.8609",
  "reference-resolvers-lite": "static-1.8537",
  "reporting-data": "static-1.69225",
  "reporting-reports": "static-1.68901",
  "reporting-snowflake": "static-1.57841",
  "reporting-testing-lib": "static-1.11158",
  "reporting-visualizations": "static-1.61299",
  "reselect": "static-3.15",
  "sales-content-partitioning": "static-1.9389",
  "sanitize": "static-1.4904",
  "sanitize-text": "static-1.8587",
  "SharedI18nStrings": "static-1.186",
  "SharedLegalStrings": "static-1.2159",
  "signup-constants": "static-1.19859",
  "signup-ui-url-generator": "static-2.8489",
  "StyleGuideUI": "static-3.514",
  "superstore": "static-1.5189",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5178",
  "ui-addon-form-validation": "static-1.11341",
  "ui-asset-management-lib": "static-1.11533",
  "ui-images": "static-2.1269",
  "UIComponents": "static-3.8868",
  "usage-tracker": "static-1.7745",
  "usage-tracker-container": "static-1.7735",
  "usage-tracker-core": "static-1.7595",
  "viral-links-lib": "static-1.7510",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.10076",
  "foundations-components": "static-1.8677",
  "immutable": "static-2.88",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1384",
  "quartz-core": "static-1.6825",
  "quick-fetch": "static-1.4203",
  "raven": "static-3.5925",
  "redux": "static-4.81",
  "redux-thunk": "static-2.83",
  "rpc-client-utils": "static-1.5101",
  "ui-addon-i18n": "static-1.11576",
  "ui-addon-upgrades": "static-9.18522",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3883",
  "quartz-webpack": "static-1.3830",
  "foundations-assets": "static-1.5316",
  "foundations-theming": "static-1.4913",
  "hub-http-janus": "static-1.901",
  "hub-http-shared-msw-handlers": "static-1.10828",
  "hubspotter-http": "static-1.4944",
  "sassPrefix": "static-1.320",
  "conversations-skeleton-state": "static-1.7602",
  "crm-message-bus": "static-1.44009",
  "customer-data-filters-ui-msw-helpers": "static-1.23689",
  "customer-data-objects-ui-components": "static-1.13461",
  "customer-data-reference-ui-components": "static-1.13598",
  "customer-data-ui-utilities": "static-1.10264",
  "events-data-lib": "static-1.677",
  "framework-builder-read-service-client": "static-1.4303",
  "hs-resources": "static-1.628",
  "immer": "static-1.104",
  "inbound-db-meta-service-client": "static-1.3751",
  "inbound-db-properties-service-client": "static-1.4121",
  "multi-account-reference-resolvers": "static-1.1433",
  "onboarding-scopes": "static-1.6883",
  "onboarding-tours": "static-1.17330",
  "pulse": "static-1.1072",
  "reporting-datasets-permissions-lib": "static-1.14692",
  "segments-client-types": "static-1.12021",
  "stylex": "static-1.45",
  "trellis-assets": "static-1.2986",
  "trellis-components": "static-1.3005",
  "trellis-theming": "static-1.1416",
  "ui-addon-teams": "static-1.21970",
  "quartz-auth": "static-1.1281",
  "ui-business-units-lib": "static-1.9526",
  "usage-tracker-session-replay": "static-1.5431",
  "ai-components-ui-library": "static-1.9945",
  "ContentUtils": "static-1.69378",
  "customer-data-properties": "static-1.52929",
  "forms-ai-lib": "static-1.4918",
  "forms-utils-lib": "static-1.13267",
  "foundations-components-test-utils": "static-1.6160",
  "react-dnd-compat": "static-1.5041",
  "react-tinymce": "static-1.56194",
  "tinymce-config": "static-2.55320",
  "ui-gdpr-components": "static-1.10651",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3898",
  "HeadJS": "static-2.816",
  "framer-motion": "static-1.83",
  "hs-test-utils-bend-plugin": "static-1.3579",
  "msw": "static-1.102",
  "msw-config": "static-1.24",
  "testing-library": "static-1.163",
  "hs-locale-management": "static-1.373",
  "ui-fonts": "static-1.1184",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4738",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1271",
  "web-vitals": "static-1.18",
  "batch-promise": "static-1.1977",
  "external-options-client-types": "static-1.4422",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.1281",
  "frontend-preferences-client": "static-1.8348",
  "graphql": "static-1.92",
  "persist-promise": "static-1.4134",
  "reporting-client-types": "static-1.2795",
  "apollo-stack-hubspot": "static-3.98",
  "growth-payments-core": "static-1.26422",
  "hubspot-apollo-client": "static-1.5309",
  "foundations-components-legacy": "static-1.1702",
  "quartz-routing": "static-1.1036",
  "hs-story-utils": "static-1.9855",
  "react-flip-move": "static-1.82",
  "nested-table": "static-1.665",
  "seat-types-lib": "static-1.969",
  "timezone-utils": "static-2.5661",
  "react-create-root-preference": "static-1.96",
  "bend-plugin-foundations-components": "static-1.4946",
  "floating-ui": "static-1.67",
  "react-aria": "static-1.76",
  "tanstack-table": "static-1.65",
  "opentelemetry-fe-types": "static-1.218",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.599",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.593",
  "quartz-test": "static-1.1281",
  "quartz-tracking": "static-1.985",
  "bend-plugin-chirp-manifest": "static-1.511",
  "chirp-fetch": "static-1.2332",
  "merchandise-lib": "static-1.283",
  "purchase-motions-components": "static-1.6577",
  "ts-schema": "static-1.4373",
  "bender-build-tools": "static-1.3518",
  "bend-plugin-foundations-theming": "static-1.3396",
  "restore-request-side-panel-lib": "static-1.1942",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.5022",
  "conditional-properties-service-client": "static-1.4093",
  "crm-pipelines-api-client-types": "static-1.4424",
  "event-emitter": "static-1.1391",
  "fdsr-migration-layer": "static-1.442",
  "multi-currency-client-types": "static-1.3989",
  "getting-started-shared-tasks": "static-1.19486",
  "growth-data-modal": "static-1.6068",
  "growth-onboarding-confetti": "static-1.3493",
  "growth-onboarding-next-action-utils": "static-1.2910",
  "navigation-components": "static-1.19084",
  "onboarding-tours-client": "static-1.5545",
  "onboarding-tours-utils": "static-1.1397",
  "ui-shepherd-react": "static-3.10705",
  "ui-shepherd-tracker": "static-1.8086",
  "ui-universal-auth": "static-1.9644",
  "user-context": "static-1.5482",
  "bend-plugin-pulse": "static-1.575",
  "fast-json-patch": "static-1.73",
  "crm-index-associations-lib": "static-1.6879",
  "stylex-utils": "static-1.166",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "hubspotter-http-shared-msw-handlers": "static-1.10826",
  "magpie-lib": "static-1.5867",
  "navigation-messaging": "static-1.8411",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23583",
  "copilot-toolkit": "static-1.12069",
  "cms-field-types": "static-1.5242",
  "content-icons-ui": "static-1.2418",
  "integrations-lib": "static-1.17325",
  "calling-global-api": "static-1.66056",
  "calling-internal-common": "static-1.31756",
  "calling-lifecycle-internal": "static-1.67438",
  "calling-lifecycle-messages": "static-1.59731",
  "commerce-products-lib": "static-1.10790",
  "crm-index-visualization-core": "static-1.4697",
  "crm-links": "static-1.6735",
  "customer-data-properties-shared-msw-handlers": "static-1.10155",
  "file-manager-components": "static-1.24765",
  "formula-editor": "static-1.14951",
  "framework-data-schema-resolvers": "static-1.7323",
  "google-libphonenumber": "static-1.48",
  "inbounddb-objects-service-types": "static-1.4503",
  "meetings-icalendar-utils-lib": "static-1.1068",
  "object-builder-ui-client": "static-1.49956",
  "pipeline-validation-client-types": "static-1.4261",
  "property-value-citations": "static-1.3543",
  "smart-data-capture-core": "static-1.387",
  "smart-property-lib": "static-1.8551",
  "tiered-pricing": "static-1.2162",
  "topics-actions-lib": "static-1.605",
  "trellis-ext-i18n": "static-1.1318",
  "trial-components-library": "static-1.14307",
  "ui-addon-iframeable": "static-1.9507",
  "zustand": "static-1.88",
  "final-form": "static-1.82",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.81",
  "rich-text-lib": "static-1.20488",
  "tinymce-themes": "static-1.57290",
  "data-token-picker": "static-1.17060",
  "hub-http-contrib": "static-1.3459",
  "interframe": "static-3.5171",
  "tinymce-data": "static-1.41405",
  "tinymce-plugins": "static-1.58434",
  "ui-addon-sales-email": "static-1.5633",
  "ui-addon-opt": "static-4.8814",
  "hubspot-apollo-cache": "static-1.768",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.578",
  "opentelemetry-web": "static-1.22",
  "beacon-keepalive-queue": "static-1.131",
  "purchase-motions-api": "static-1.6580",
  "onboarding-data-sync-lib": "static-1.2772",
  "growth-onboarding-next-action-components": "static-1.2938",
  "user-context-client": "static-1.4939",
  "idb-keyval": "static-1.54",
  "magpie-types": "static-1.5327",
  "nest": "static-1.666",
  "reactive-lib": "static-1.1154",
  "simple-logging-lib": "static-1.3482",
  "unified-auth-core-lib": "static-1.1440",
  "getting-started-shared-tasks-store": "static-1.18604",
  "nav-meta": "static-1.30721",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.2035",
  "integrations-error-boundary-lib": "static-1.14740",
  "integrations-tracking-lib": "static-1.6043",
  "native-integrations-shared-strings": "static-1.8193",
  "redux-observable": "static-1.78",
  "ReduxMessenger": "static-2.10802",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1158",
  "calling-error-reporting": "static-1.31763",
  "shared-worker-versioning": "static-1.11472",
  "calling-usage-tracker": "static-1.6965",
  "voice-sms-access-library": "static-1.2344",
  "customer-data-tracking": "static-1.7303",
  "commerce-permissions": "static-1.1211",
  "products-iframe-lib": "static-1.8824",
  "products-ui-components-shared-msw-handlers": "static-1.11210",
  "framework-data-schema-quick-fetch": "static-1.7228",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10911",
  "sales-views-client-types": "static-1.4689",
  "location-customization-utils-lib": "static-1.10340",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4571",
  "poll-commands": "static-1.3905",
  "video-components-external": "static-1.12355",
  "video-data-lib": "static-1.36013",
  "bark-lib": "static-1.16961",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.105",
  "crm-properties-common-lib": "static-1.6319",
  "react-codemirror": "static-1.11070",
  "data-agent-kit": "static-1.833",
  "feedback-loader": "static-1.29994",
  "fsm": "static-1.4185",
  "policy-lib": "static-1.7236",
  "react-colorpicker": "static-2.10643",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10974",
  "embedded-academy-lib": "static-1.15891",
  "hubs-service-types": "static-1.1695",
  "nudge-client-utils": "static-1.3342",
  "salesImages": "static-1.687",
  "FileManagerLib": "static-1.40405",
  "NamespacedHubStyle": "static-2.9337",
  "FileManagerCore": "static-1.40264",
  "content-assistance-lib": "static-1.8358",
  "layout-dnd-components": "static-1.13149",
  "layout-dnd-utils": "static-1.12124",
  "ui-addon-emoji-picker": "static-1.10297",
  "ui-brand-identity-lib": "static-1.16827",
  "InboxConnectUtils": "static-4.15771",
  "meetings-connect-utils-lib": "static-1.8047",
  "breeze-engine-chat-components": "static-1.1013",
  "breeze-engine-core": "static-1.1313",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "universal-page-editor-lib": "static-1.3439",
  "adobe-sign-auth-lib": "static-1.687",
  "ads-unified-auth-lib": "static-1.1805",
  "custom-vendor-connection-lib": "static-1.208",
  "google-sheets-integration-lib": "static-1.1254",
  "microsoft-drive-auth-lib": "static-1.415",
  "surveymonkey-integration-lib": "static-1.783",
  "slack-ui-library": "static-1.10827",
  "calling-orchestration-schema": "static-1.37121",
  "crm-record-cards-service-types": "static-1.3842",
  "content-media-composition-data-lib": "static-1.13509",
  "content-media-compositions": "static-2.17516",
  "media-bridge-lib": "static-1.19576",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16591",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4933",
  "storybook-react": "static-1.43",
  "academy-common-lib": "static-1.15351",
  "nudge-custom-function-registry": "static-1.3099",
  "nudge-renderer-utils": "static-1.3418",
  "whisper-core-api": "static-1.7564",
  "audio-components": "static-1.6508",
  "FileManagerImages": "static-1.37916",
  "video-components": "static-1.14357",
  "breeze-artifacts-sdk": "static-1.735",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.64",
  "urlinator": "static-1.4946",
  "video-embed": "static-1.36847",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29528",
  "ContentData": "static-1.69453",
  "layout-data-lib": "static-1.10449",
  "academy-service-client": "static-1.4124",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4824",
  "trellis-ecosystem": "static-1.7787",
  "ui-addon-react-router-dom": "static-1.9960",
  "wootric-nps": "static-1.7274",
  "social-insights-client-types": "static-1.22863",
  "outpost": "static-1.4564",
  "growth-onboarding-feedback-components": "static-1.7013",
  "advanced-menus-core": "static-1.15746",
  "advanced-menus-lib": "static-1.12515",
  "ExportDialog": "static-6.10802",
  "ui-memberships-settings-lib": "static-1.35103",
  "marketplace-ui-apps-core": "static-1.19508",
  "marketplace-ui-common": "static-1.20976",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15745",
  "simple-menus-lib": "static-1.17262",
  "settings-ui-lib": "static-1.12961",
  "developer-experience-shared-components": "static-1.10969",
  "immutable-less": "static-1.5082",
  "marketplace-ui-client-types": "static-1.18383",
  "ui-addon-integrations-directory-panel": "static-2.8389",
  "ui-extensibility-client-types": "static-1.4347",
  "ai-settings-ui-library": "static-1.8512",
  "ui-product-approvals-common": "static-1.1464",
  "apps-service-types": "static-1.4077",
  "oauth-service-types": "static-1.4597",
  "simple-data-table": "static-1.3753"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35464",
  "atom": "/atom/static-1.5508",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2915",
  "client-types": "/client-types/static-1.507",
  "cssUtils": "/cssUtils/static-1.1053",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41254",
  "customer-data-objects": "/customer-data-objects/static-1.8124",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8475",
  "documents-lib": "/documents-lib/static-1.35469",
  "emoji-mart": "/emoji-mart/static-3.6",
  "flux-actions": "/flux-actions/static-1.380",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86764",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5145",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2629",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.114",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6020",
  "hs-test-utils": "/hs-test-utils/static-1.8468",
  "hub-http": "/hub-http/static-1.6639",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyle": "/HubStyle/static-2.12229",
  "HubStyleTokens": "/HubStyleTokens/static-2.11922",
  "I18n": "/I18n/static-7.1698",
  "icons": "/icons/static-2.699",
  "jasmine-immutable": "/jasmine-immutable/static-1.3373",
  "jasmine-runner": "/jasmine-runner/static-1.6881",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7581",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3316",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5810",
  "quartz": "/quartz/static-1.7606",
  "react": "/react/static-7.202",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17165",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5635",
  "react-virtualized": "/react-virtualized/static-2.111",
  "reference-resolvers": "/reference-resolvers/static-1.8609",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8537",
  "reporting-data": "/reporting-data/static-1.69225",
  "reporting-reports": "/reporting-reports/static-1.68901",
  "reporting-snowflake": "/reporting-snowflake/static-1.57841",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11158",
  "reporting-visualizations": "/reporting-visualizations/static-1.61299",
  "reselect": "/reselect/static-3.15",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9389",
  "sanitize": "/sanitize/static-1.4904",
  "sanitize-text": "/sanitize-text/static-1.8587",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2159",
  "signup-constants": "/signup-constants/static-1.19859",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8489",
  "StyleGuideUI": "/StyleGuideUI/static-3.514",
  "superstore": "/superstore/static-1.5189",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5178",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11341",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11533",
  "ui-images": "/ui-images/static-2.1269",
  "UIComponents": "/UIComponents/static-3.8868",
  "usage-tracker": "/usage-tracker/static-1.7745",
  "usage-tracker-container": "/usage-tracker-container/static-1.7735",
  "usage-tracker-core": "/usage-tracker-core/static-1.7595",
  "viral-links-lib": "/viral-links-lib/static-1.7510",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.10076",
  "foundations-components": "/foundations-components/static-1.8677",
  "immutable": "/immutable/static-2.88",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1384",
  "quartz-core": "/quartz-core/static-1.6825",
  "quick-fetch": "/quick-fetch/static-1.4203",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.83",
  "rpc-client-utils": "/rpc-client-utils/static-1.5101",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11576",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18522",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3883",
  "quartz-webpack": "/quartz-webpack/static-1.3830",
  "foundations-assets": "/foundations-assets/static-1.5316",
  "foundations-theming": "/foundations-theming/static-1.4913",
  "hub-http-janus": "/hub-http-janus/static-1.901",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10828",
  "hubspotter-http": "/hubspotter-http/static-1.4944",
  "sassPrefix": "/sassPrefix/static-1.320",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "crm-message-bus": "/crm-message-bus/static-1.44009",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23689",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13461",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13598",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10264",
  "events-data-lib": "/events-data-lib/static-1.677",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4303",
  "hs-resources": "/hs-resources/static-1.628",
  "immer": "/immer/static-1.104",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3751",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4121",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1433",
  "onboarding-scopes": "/onboarding-scopes/static-1.6883",
  "onboarding-tours": "/onboarding-tours/static-1.17330",
  "pulse": "/pulse/static-1.1072",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14692",
  "segments-client-types": "/segments-client-types/static-1.12021",
  "stylex": "/stylex/static-1.45",
  "trellis-assets": "/trellis-assets/static-1.2986",
  "trellis-components": "/trellis-components/static-1.3005",
  "trellis-theming": "/trellis-theming/static-1.1416",
  "ui-addon-teams": "/ui-addon-teams/static-1.21970",
  "quartz-auth": "/quartz-auth/static-1.1281",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9526",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5431",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9945",
  "ContentUtils": "/ContentUtils/static-1.69378",
  "customer-data-properties": "/customer-data-properties/static-1.52929",
  "forms-ai-lib": "/forms-ai-lib/static-1.4918",
  "forms-utils-lib": "/forms-utils-lib/static-1.13267",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6160",
  "react-dnd-compat": "/react-dnd-compat/static-1.5041",
  "react-tinymce": "/react-tinymce/static-1.56194",
  "tinymce-config": "/tinymce-config/static-2.55320",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10651",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3898",
  "HeadJS": "/HeadJS/static-2.816",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3579",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.24",
  "testing-library": "/testing-library/static-1.163",
  "hs-locale-management": "/hs-locale-management/static-1.373",
  "ui-fonts": "/ui-fonts/static-1.1184",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4738",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1271",
  "web-vitals": "/web-vitals/static-1.18",
  "batch-promise": "/batch-promise/static-1.1977",
  "external-options-client-types": "/external-options-client-types/static-1.4422",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.1281",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8348",
  "graphql": "/graphql/static-1.92",
  "persist-promise": "/persist-promise/static-1.4134",
  "reporting-client-types": "/reporting-client-types/static-1.2795",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.98",
  "growth-payments-core": "/growth-payments-core/static-1.26422",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5309",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1702",
  "quartz-routing": "/quartz-routing/static-1.1036",
  "hs-story-utils": "/hs-story-utils/static-1.9855",
  "react-flip-move": "/react-flip-move/static-1.82",
  "nested-table": "/nested-table/static-1.665",
  "seat-types-lib": "/seat-types-lib/static-1.969",
  "timezone-utils": "/timezone-utils/static-2.5661",
  "react-create-root-preference": "/react-create-root-preference/static-1.96",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4946",
  "floating-ui": "/floating-ui/static-1.67",
  "react-aria": "/react-aria/static-1.76",
  "tanstack-table": "/tanstack-table/static-1.65",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.218",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.599",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.593",
  "quartz-test": "/quartz-test/static-1.1281",
  "quartz-tracking": "/quartz-tracking/static-1.985",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.511",
  "chirp-fetch": "/chirp-fetch/static-1.2332",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "purchase-motions-components": "/purchase-motions-components/static-1.6577",
  "ts-schema": "/ts-schema/static-1.4373",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3396",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1942",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5022",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4093",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4424",
  "event-emitter": "/event-emitter/static-1.1391",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.442",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3989",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19486",
  "growth-data-modal": "/growth-data-modal/static-1.6068",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3493",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2910",
  "navigation-components": "/navigation-components/static-1.19084",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5545",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1397",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10705",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8086",
  "ui-universal-auth": "/ui-universal-auth/static-1.9644",
  "user-context": "/user-context/static-1.5482",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.575",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6879",
  "stylex-utils": "/stylex-utils/static-1.166",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10826",
  "magpie-lib": "/magpie-lib/static-1.5867",
  "navigation-messaging": "/navigation-messaging/static-1.8411",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23583",
  "copilot-toolkit": "/copilot-toolkit/static-1.12069",
  "cms-field-types": "/cms-field-types/static-1.5242",
  "content-icons-ui": "/content-icons-ui/static-1.2418",
  "integrations-lib": "/integrations-lib/static-1.17325",
  "calling-global-api": "/calling-global-api/static-1.66056",
  "calling-internal-common": "/calling-internal-common/static-1.31756",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67438",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59731",
  "commerce-products-lib": "/commerce-products-lib/static-1.10790",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4697",
  "crm-links": "/crm-links/static-1.6735",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10155",
  "file-manager-components": "/file-manager-components/static-1.24765",
  "formula-editor": "/formula-editor/static-1.14951",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7323",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4503",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1068",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49956",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4261",
  "property-value-citations": "/property-value-citations/static-1.3543",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.387",
  "smart-property-lib": "/smart-property-lib/static-1.8551",
  "tiered-pricing": "/tiered-pricing/static-1.2162",
  "topics-actions-lib": "/topics-actions-lib/static-1.605",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1318",
  "trial-components-library": "/trial-components-library/static-1.14307",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9507",
  "zustand": "/zustand/static-1.88",
  "final-form": "/final-form/static-1.82",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "rich-text-lib": "/rich-text-lib/static-1.20488",
  "tinymce-themes": "/tinymce-themes/static-1.57290",
  "data-token-picker": "/data-token-picker/static-1.17060",
  "hub-http-contrib": "/hub-http-contrib/static-1.3459",
  "interframe": "/interframe/static-3.5171",
  "tinymce-data": "/tinymce-data/static-1.41405",
  "tinymce-plugins": "/tinymce-plugins/static-1.58434",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5633",
  "ui-addon-opt": "/ui-addon-opt/static-4.8814",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.768",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.578",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.131",
  "purchase-motions-api": "/purchase-motions-api/static-1.6580",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2772",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2938",
  "user-context-client": "/user-context-client/static-1.4939",
  "idb-keyval": "/idb-keyval/static-1.54",
  "magpie-types": "/magpie-types/static-1.5327",
  "nest": "/nest/static-1.666",
  "reactive-lib": "/reactive-lib/static-1.1154",
  "simple-logging-lib": "/simple-logging-lib/static-1.3482",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1440",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18604",
  "nav-meta": "/nav-meta/static-1.30721",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2035",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14740",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6043",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8193",
  "redux-observable": "/redux-observable/static-1.78",
  "ReduxMessenger": "/ReduxMessenger/static-2.10802",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1158",
  "calling-error-reporting": "/calling-error-reporting/static-1.31763",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11472",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6965",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2344",
  "customer-data-tracking": "/customer-data-tracking/static-1.7303",
  "commerce-permissions": "/commerce-permissions/static-1.1211",
  "products-iframe-lib": "/products-iframe-lib/static-1.8824",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11210",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7228",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10911",
  "sales-views-client-types": "/sales-views-client-types/static-1.4689",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10340",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4571",
  "poll-commands": "/poll-commands/static-1.3905",
  "video-components-external": "/video-components-external/static-1.12355",
  "video-data-lib": "/video-data-lib/static-1.36013",
  "bark-lib": "/bark-lib/static-1.16961",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.105",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6319",
  "react-codemirror": "/react-codemirror/static-1.11070",
  "data-agent-kit": "/data-agent-kit/static-1.833",
  "feedback-loader": "/feedback-loader/static-1.29994",
  "fsm": "/fsm/static-1.4185",
  "policy-lib": "/policy-lib/static-1.7236",
  "react-colorpicker": "/react-colorpicker/static-2.10643",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10974",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15891",
  "hubs-service-types": "/hubs-service-types/static-1.1695",
  "nudge-client-utils": "/nudge-client-utils/static-1.3342",
  "salesImages": "/salesImages/static-1.687",
  "FileManagerLib": "/FileManagerLib/static-1.40405",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9337",
  "FileManagerCore": "/FileManagerCore/static-1.40264",
  "content-assistance-lib": "/content-assistance-lib/static-1.8358",
  "layout-dnd-components": "/layout-dnd-components/static-1.13149",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12124",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10297",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16827",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15771",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8047",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1013",
  "breeze-engine-core": "/breeze-engine-core/static-1.1313",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3439",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.687",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1805",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.208",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1254",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.415",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.783",
  "slack-ui-library": "/slack-ui-library/static-1.10827",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37121",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3842",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13509",
  "content-media-compositions": "/content-media-compositions/static-2.17516",
  "media-bridge-lib": "/media-bridge-lib/static-1.19576",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16591",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4933",
  "storybook-react": "/storybook-react/static-1.43",
  "academy-common-lib": "/academy-common-lib/static-1.15351",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3099",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3418",
  "whisper-core-api": "/whisper-core-api/static-1.7564",
  "audio-components": "/audio-components/static-1.6508",
  "FileManagerImages": "/FileManagerImages/static-1.37916",
  "video-components": "/video-components/static-1.14357",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.735",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.64",
  "urlinator": "/urlinator/static-1.4946",
  "video-embed": "/video-embed/static-1.36847",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29528",
  "ContentData": "/ContentData/static-1.69453",
  "layout-data-lib": "/layout-data-lib/static-1.10449",
  "academy-service-client": "/academy-service-client/static-1.4124",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4824",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7787",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9960",
  "wootric-nps": "/wootric-nps/static-1.7274",
  "social-insights-client-types": "/social-insights-client-types/static-1.22863",
  "outpost": "/outpost/static-1.4564",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7013",
  "advanced-menus-core": "/advanced-menus-core/static-1.15746",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12515",
  "ExportDialog": "/ExportDialog/static-6.10802",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35103",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19508",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20976",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15745",
  "simple-menus-lib": "/simple-menus-lib/static-1.17262",
  "settings-ui-lib": "/settings-ui-lib/static-1.12961",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10969",
  "immutable-less": "/immutable-less/static-1.5082",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18383",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8389",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4347",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8512",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1464",
  "apps-service-types": "/apps-service-types/static-1.4077",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "simple-data-table": "/simple-data-table/static-1.3753"
}
};
